import Image from 'next/image';
import React from 'react';
import { TrendingBlogPost } from '../../../../pages/blog';
import Link from 'next/link';

interface BriefBlogCardProps {
  blog: TrendingBlogPost;
}

export default function BriefBlogCard({ blog }: BriefBlogCardProps) {
  return (
    <Link
      className="h-[100px] justify-between w-full items-start gap-3 sm:gap-[20px] inline-flex cursor-pointer hover:scale-105 ease-in-out duration-200"
      href={`/blog/${blog.slug}`}
      target="_blank"
    >
      <div className="w-[150px] lg:w-[150px] 2xl:w-[155px]">
        <Image
          width={144}
          height={100}
          alt={blog.image?.alternativeText ?? 'latest-blog'}
          className="w-full h-[90px] sm:h-[100px] object-cover"
          src={blog.image?.url}
        />
      </div>

      <div className="flex-col justify-start items-start gap-[25px] inline-flex w-[60%] mmsm:w-[65%] sm:w-[60%] mlg:w-[65%] xl:w-[50%] mxl:w-[55%] 2xl:w-[60%] 3xl:w-[70%]">
        <div
          id="title"
          className="sm:h-[56px] overflow-hidden"
          style={{
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical'
          }}
        >
          <h1 className="text-black2 text-sm lg:text-[15px] 3xl:text-[17px] font-normal">
            {blog?.page_title?.includes('-') &&
            blog?.page_title?.split('-')?.pop()?.trim() === 'See Sight Tours'
              ? blog.page_title.split('-').slice(0, -1).join('-').trim()
              : blog.page_title}
          </h1>
        </div>
        <div className="self-stretch text-gray75 text-xs sm:text-[13px] lg:text-sm font-normal leading-tight tracking-tight">
          {blog.publication_date}
        </div>
      </div>
    </Link>
  );
}
